import z from 'zod';

import { WorkoutPlanId } from '../../../BrandedIds';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const CompleteRepaymentWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('completeRepaymentWorkoutPlan'),
  workoutPlanId: WorkoutPlanId,
});
export type CompleteRepaymentWorkoutPlanEvent = z.infer<typeof CompleteRepaymentWorkoutPlanEvent>;
